import React, { createContext, useContext, useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
const WebSocketContext = createContext(null);

export const WebSocketProvider = ({ children }) => {
    const [webSocket, setWebSocket] = useState(null);

    useEffect(() => {
        let ws;
        let pingInterval;
        const reconnectDelay = 500; // Reconnect delay in milliseconds

        const connectWebSocket = () => {
            ws = new WebSocket(process.env.REACT_APP_WEB_SOCKET_URL);
            //ws = new WebSocket('ws://localhost:5000/');
            setWebSocket(ws);
            const token = localStorage.getItem('token')
            if (token){
                ws.onopen = () => {
                    // console.log('WebSocket Connected');
                    ws.send(JSON.stringify({ type: 'authenticate', token: token }));
                    // ws.send(JSON.stringify("data from client"));
                    pingInterval = setInterval(() => {
                        if (ws.readyState === WebSocket.OPEN) {
                            ws.send('ping'); // send a ping message
                            // console.log("pong from server")
                        }
                    }, 30000);
                };
            }
            
            ws.onerror = (error) => console.log('WebSocket Error: ', error); 

            ws.onclose = () => {
                // console.log('WebSocket Disconnected');
                clearInterval(pingInterval);
                // Attempt to reconnect with a delay
                setTimeout(connectWebSocket, reconnectDelay);
            };

            // Uncomment and modify this part as needed for your application
            // ws.onmessage = (event) => {
            //     if (event.data === 'pong') {
            //         console.log('Pong received');
            //         // handle pong response
            //     }
            //     // Handle other messages
            // };
        };

        connectWebSocket();

        return () => {
            ws.close();
        };
    }, []);

    return (
        <WebSocketContext.Provider value={webSocket}>
            {children}
            {/* <Outlet /> */}
        </WebSocketContext.Provider>
    );
};


export default WebSocketProvider;

export const useWebSocket = () => {
    return useContext(WebSocketContext); 
};

